export const getWidgetTypeFromState = (state) => state.dashboardReducer.widgetTypes;
export const getAllDashboardsFromState = (state) => state.dashboardReducer.dashboards;
